module.exports = __webpack_public_path__ + "static/media/132-wifi.5aab5127.svg";